import { Uuid } from "helpers/types/uuid"
import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"
import { ResourceResult } from "helpers/data-statuses"

export interface Experiment {
  id: Uuid
  name: string
  description: string
  resourceId: Uuid | string
  type: string
  modelId: string | null
  config: unknown | null
}

export function useExperiments(enabled = true): ResourceResult<Experiment[]> {
  const account = useAccountAlias()

  return useResource<Experiment[]>({
    resource: "experiments",
    url: () => enabled && account ? `/api/${account}/experiments` : null,
  }, "experiments")
}
